import { Popup } from 'components/Popup'
import { BUTTON_TYPES, Button } from 'components/Button'
import { BTN_TXT } from 'constants/txt'
import { useFinancialsPopup } from 'features/Financials/Providers/FinancialsPopupProvider'
import { useCallback, useEffect, useState } from 'react'
import { Typography } from 'components/Typography'
import { TRebatePaymentData } from './types'
import { fetchRebatePaymentData } from './api'
import { validateRebatesPaymentData } from './helpers'
import { formatAmount } from 'helper/common'

export const ConfirmRebatesPaymentPopup = () => {
  const {
    initiateRebatesPaymentPopup,
    confirmRebatesPaymentPopup: { actions, state }
  } = useFinancialsPopup()

  const { row } = state.payload

  const [rebatePaymentData, setRebatePaymentData] =
    useState<TRebatePaymentData | null>(null)

  useEffect(() => {
    if (!row?.uuid) return
    fetchRebatePaymentData(row.uuid).then((data) => {
      setRebatePaymentData(data.data)
    })
  }, [row?.uuid])

  const onCancel = useCallback(() => {
    actions.close()
  }, [actions])

  const onConfirm = useCallback(() => {
    if (!rebatePaymentData) return
    actions.close()
    const isValid = validateRebatesPaymentData(rebatePaymentData)
    if (!isValid) return
    initiateRebatesPaymentPopup.actions.open({
      row: state.payload.row,
      rebatePaymentData
    })
  }, [
    actions,
    initiateRebatesPaymentPopup.actions,
    rebatePaymentData,
    state.payload.row
  ])

  if (!row) return null

  return (
    <>
      <Popup
        {...state}
        zIndex={10000}
        footer={
          <>
            <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
              {BTN_TXT.CANCEL}
            </Button>
            <Button type={BUTTON_TYPES.PRIMARY} onClick={onConfirm} upperCase>
              {BTN_TXT.PROCEED}
            </Button>
          </>
        }
      >
        <Typography.Body1>
          Rebates of {formatAmount(row.total)} will be paid to{' '}
          {row.hospital_name}. Do you want to proceed?
        </Typography.Body1>
      </Popup>
    </>
  )
}
